import { render, staticRenderFns } from "./FlexbenMenu.vue?vue&type=template&id=3994501d&scoped=true"
import script from "./FlexbenMenu.vue?vue&type=script&lang=js"
export * from "./FlexbenMenu.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=3994501d&prod&scoped=true&lang=css&external"
import style1 from "./FlexbenMenu.vue?vue&type=style&index=1&id=3994501d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994501d",
  null
  
)

export default component.exports